// frontend/src/pages/Admin/ManageInternships.jsx
import React, { useEffect, useState } from "react";
import {
  getInternships,
  createInternship,
  updateInternship,
  deleteInternship,
} from "../../services/api";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaGraduationCap,
} from "react-icons/fa";

const ManageInternships = () => {
  const [internships, setInternships] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingInternship, setEditingInternship] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    ref: "",
    year: new Date().getFullYear(),
    type: "PFE",
    description: "",
    requirements: "",
    duration: "",
    available: true,
    published: true,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchInternships();
  }, []);

  const fetchInternships = async () => {
    try {
      const response = await getInternships();
      setInternships(response.data);
    } catch (error) {
      console.error("Erreur:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = {
        ...formData,
        requirements: JSON.stringify(
          formData.requirements.split("\n").filter((r) => r.trim())
        ),
      };

      if (editingInternship) {
        await updateInternship(editingInternship._id, data);
      } else {
        await createInternship(data);
      }

      fetchInternships();
      resetForm();
    } catch (error) {
      console.error("Erreur:", error);
      alert(error.response?.data?.message || "Erreur lors de l'enregistrement");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (internship) => {
    setEditingInternship(internship);
    setFormData({
      title: internship.title,
      ref: internship.ref,
      year: internship.year,
      type: internship.type,
      description: internship.description || "",
      requirements: internship.requirements?.join("\n") || "",
      duration: internship.duration || "",
      available: internship.available,
      published: internship.published,
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce stage ?"))
      return;

    try {
      await deleteInternship(id);
      fetchInternships();
    } catch (error) {
      console.error("Erreur:", error);
      alert(error.response?.data?.message || "Erreur lors de la suppression");
    }
  };

  const resetForm = () => {
    setFormData({
      title: "",
      ref: "",
      year: new Date().getFullYear(),
      type: "PFE",
      description: "",
      requirements: "",
      duration: "",
      available: true,
      published: true,
    });
    setEditingInternship(null);
    setShowForm(false);
  };

  return (
    <div className="py-8 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <FaGraduationCap className="text-blue-600" size={32} />
            <h1 className="text-3xl font-bold text-gray-800">
              Gestion des Stages & PFE
            </h1>
          </div>
          <button
            onClick={() => setShowForm(!showForm)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <FaPlus />
            Nouveau Stage
          </button>
        </div>

        {showForm && (
          <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              {editingInternship ? "Modifier le Stage" : "Nouveau Stage"}
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Titre <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Référence <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.ref}
                    onChange={(e) =>
                      setFormData({ ...formData, ref: e.target.value })
                    }
                    required
                    placeholder="Ex: PFE-2024-001"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Type <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={formData.type}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="PFE">PFE</option>
                    <option value="Stage Ingénieur">Stage Ingénieur</option>
                    <option value="Stage Technicien">Stage Technicien</option>
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Année <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    value={formData.year}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        year: parseInt(e.target.value),
                      })
                    }
                    required
                    min="2024"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
       

                
              </div>

              

              

              <div className="flex gap-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400"
                >
                  {loading ? "Enregistrement..." : "Enregistrer"}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors"
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-left text-gray-700 font-semibold">
                  Référence
                </th>
                <th className="px-6 py-3 text-left text-gray-700 font-semibold">
                  Titre
                </th>
                <th className="px-6 py-3 text-left text-gray-700 font-semibold">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-gray-700 font-semibold">
                  Année
                </th>
                
                <th className="px-6 py-3 text-right text-gray-700 font-semibold">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {internships.map((internship) => (
                <tr key={internship._id} className="border-t hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium">{internship.ref}</td>
                  <td className="px-6 py-4">{internship.title}</td>
                  <td className="px-6 py-4">
                    <span className="px-2 py-1 bg-blue-100 text-blue-600 text-sm rounded">
                      {internship.type}
                    </span>
                  </td>
                  <td className="px-6 py-4">{internship.year}</td>
                  
                  <td className="px-6 py-4 text-right">
                    <button
                      onClick={() => handleEdit(internship)}
                      className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-600 rounded hover:bg-blue-200 mr-2"
                    >
                      <FaEdit size={14} />
                      Modifier
                    </button>
                    <button
                      onClick={() => handleDelete(internship._id)}
                      className="inline-flex items-center gap-1 px-3 py-1 bg-red-100 text-red-600 rounded hover:bg-red-200"
                    >
                      <FaTrash size={14} />
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageInternships;
